{
  "colorInputLabel": "{label}, {channelLabel}",
  "colorNameAndValue": "{name}: {value}",
  "colorPicker": "Izbirnik barv",
  "colorSwatch": "barvna paleta",
  "transparent": "prozorno",
  "twoDimensionalSlider": "2D drsnik"
}
